import { useFilterState } from '../hooks/useFilterState'

export const WithFilterState = (props: { children: Function }) => {
  const { filterState, updateFilterState } = useFilterState()
  return props.children({ filterState, updateFilterState })
}
